document.addEventListener('DOMContentLoaded', () => {
    const targetElement = document.querySelector('.sticky-button');
    if (targetElement) {
        document.addEventListener('scroll', (event) => {
          if (document.body.getBoundingClientRect().y > -50) {
            targetElement.style.visibility = 'hidden';
          } else {
            targetElement.style.visibility = 'visible';
          }            
        });
    }
});
